/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const RemoveRowIcon = /*#__PURE__*/ createSvgIcon(
  'RemoveRowIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M4.5 10.75v4.75h11v-4.75h-11zm0 6.25c-.412 0-.766-.147-1.06-.44A1.445 1.445 0 013 15.5v-11c0-.412.147-.766.44-1.06A1.44 1.44 0 014.496 3h.749c.212 0 .39.071.536.214.146.143.219.32.219.532 0 .21-.072.39-.216.535a.72.72 0 01-.534.219H4.5v4.75h11V4.5h-.746a.736.736 0 01-.535-.214.714.714 0 01-.219-.532c0-.21.072-.39.216-.535A.723.723 0 0114.752 3h.752c.414 0 .767.147 1.059.44.291.294.437.648.437 1.06v11c0 .412-.147.766-.44 1.06-.294.293-.647.44-1.06.44h-11z"
            fill="currentColor"
          />
          <path
            d="M8.25 4.5h3.5a.72.72 0 00.534-.219.734.734 0 00.216-.535.72.72 0 00-.216-.532A.728.728 0 0011.75 3h-3.5a.72.72 0 00-.534.219.734.734 0 00-.216.535.72.72 0 00.216.532.728.728 0 00.534.214z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default RemoveRowIcon;
